<template>
  <div>
      <listaCultivos :items="items"/>      
  </div>
</template>


<script>
import CultivosService from "@/services/CultivosService";
import listaCultivos from '@/components/listaCultivos.vue';

export default {
  components: { listaCultivos },
  name: "cultivos",
  props: {
    msg: String,
  },
  data: () => ({
    selected: [],
    items: [],
    reveal: false,
  }),
  mounted() {
    this.$Progress.start();
    this.traerdata();
    //console.log('items :>> ', this.items);
  },
  methods: {
    traerdata() {
      const cultivo_service = new CultivosService();
      cultivo_service.getCultivos("cultivos")
      .then((result) => {        
        this.$Progress.finish();          
        result.forEach((doc) => {          
          this.items.push(doc.data())
          //console.log(doc.data());
          //console.log('doc.id :>> ', doc.id);
        });

      })
      .catch((err) => {
        this.$Progress.fail();
        console.log("object :>> ", err);
      })  

    },
    async crear_cultivo() {
      this.$Progress.start();
      try {       
        

        // const cultivo_service = new CultivosService();       
        //  hrc.forEach(element => {        
        //     const cultivo = {
        //       nombre: element.nombre, 
        //       detalle: element.detalle, 
        //       fotos: element.fotos         
        //     };             
        //     cultivo_service.getCrearCultivos(cultivo, "cultivos");           
        //    //console.log('cultivo :>> ', cultivo);
        //  });

        this.$Progress.finish();    

        // product_service.getCrearProd(prod, key);
        
      } catch (e) {
        console.error("Error adding document: ", e);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>
